import React from 'react';
import {
  PieChart,
  Users,
  BarChart,
  Server,
  Repeat,
  Settings,
  Layers,
  UserCheck,
  CreditCard,
  Zap,
  ShieldAlert,
  Archive,
  Bot,
  Radio,
  Bell,
} from 'lucide-react';
import { PERMISSIONS } from '../../utils/hasPermission';

// ----------------------------------------------------------------------

const getIcon = (IconComponent) => <IconComponent size={18} strokeWidth={2} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(PieChart),
  },
  {
    title: 'Staff & Permissions',
    path: '/dashboard/staff',
    icon: getIcon(UserCheck),
    permission: PERMISSIONS.STAFF_READ,
  },
  {
    title: 'users',
    path: '/dashboard/user-management',
    icon: getIcon(Users),
    permission: PERMISSIONS.AGENTS_READ,
  },
  {
    title: 'analytics',
    path: '/dashboard/analytics',
    icon: getIcon(BarChart),
    permission: PERMISSIONS.TRANSACTIONS_ANALYTICS,
  },
  {
    title: 'Ad Campaigns',
    path: '/dashboard/campaigns',
    icon: getIcon(Layers),
    permission: PERMISSIONS.CAMPAIGNS_READ,
  },
  {
    title: 'Notifications',
    path: '/dashboard/notifications',
    icon: getIcon(Bell),
    permission: PERMISSIONS.NOTIFICATIONS_READ,
  },
  {
    title: 'Services',
    path: '/dashboard/services',
    icon: getIcon(Archive),
    permission: PERMISSIONS.SERVICES_READ,
  },
  // {
  //   title: 'Services (Legacy)',
  //   path: '/dashboard/services-legacy',
  //   icon: getIcon(Archive),
  //   permission: PERMISSIONS.SERVICES_READ,
  // },
  {
    title: 'Service Providers',
    path: '/dashboard/service-providers',
    icon: getIcon(Server),
    adminOrOwnerOnly: true,
  },
  {
    title: 'API Services',
    path: '/dashboard/reselling',
    icon: getIcon(Layers),
    permission: PERMISSIONS.SERVICES_READ,
  },
  {
    title: 'Bots',
    path: '/dashboard/bots',
    icon: getIcon(Bot),
    permission: [PERMISSIONS.SYSTEM_SETTINGS_READ, PERMISSIONS.SYSTEM_SETTINGS_UPDATE],
  },
  {
    title: 'USSD',
    path: '/dashboard/ussd',
    icon: getIcon(Radio),
    permission: [PERMISSIONS.SYSTEM_SETTINGS_READ, PERMISSIONS.SYSTEM_SETTINGS_UPDATE],
  },
  {
    title: 'Transactions',
    path: '/dashboard/transaction',
    icon: getIcon(Repeat),
    permission: PERMISSIONS.TRANSACTIONS_READ,
    children: [
      {
        title: 'Live Transactions',
        path: '/dashboard/transactions/live',
        adminOrOwnerOnly: true,
        info: (
          <span
            style={{
              fontSize: '0.62rem',
              fontWeight: 800,
              letterSpacing: '0.05em',
              padding: '2px 6px',
              borderRadius: 999,
              backgroundColor: 'rgba(5, 150, 105, 0.14)',
              color: '#059669',
            }}
          >
            LIVE
          </span>
        ),
      },
      {
        title: 'All Transactions',
        path: '/dashboard/transaction',
      },
    ],
  },
  {
    title: 'Audit Logs',
    path: '/dashboard/audit-logs',
    icon: getIcon(ShieldAlert),
    permission: PERMISSIONS.AUDIT_READ,
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: getIcon(Settings),
    permission: [PERMISSIONS.SYSTEM_SETTINGS_READ, PERMISSIONS.SYSTEM_SETTINGS_UPDATE],
  },
  {
    title: 'Billings',
    path: '/dashboard/billing',
    icon: getIcon(CreditCard),
    isOwnerOnly: true,
  },
  // process.env.FEATURE_TOGGLE_BILLING_ACTIVES && {
  //   title: 'Feature Activations',
  //   path: '/dashboard/activations',
  //   icon: getIcon(Zap),
  //   isOwnerOnly: true,
  // },
];

export default navConfig;
